// Build SEO-friendly, unique slugs for card URLs.
// Format: `${slugify(name)}-${slugify(subtitle)}-${shortId}` where shortId
// is the last 8 chars of the card UUID. Stable, unique, readable.

export function slugify(input: string | null | undefined): string {
  if (!input) return '';
  return input
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
}

export function shortIdFromUuid(id: string): string {
  return id.replace(/-/g, '').slice(-8);
}

export function cardSlug(card: { id: string; name: string; subtitle?: string | null }): string {
  const parts = [slugify(card.name), slugify(card.subtitle), shortIdFromUuid(card.id)].filter(Boolean);
  return parts.join('-');
}

/** Extract the short id (last 8 hex chars) from a slug, or null if not present. */
export function shortIdFromSlug(slug: string): string | null {
  const m = slug.match(/-([a-f0-9]{8})$/i);
  return m ? m[1].toLowerCase() : null;
}

export function cardPath(card: { id: string; name: string; subtitle?: string | null }): string {
  return `/cards/${cardSlug(card)}`;
}
